import  {  Component } from "@angular/core";

@Component({
  selector: 'app-footer-component',
  templateUrl: './footer.html',
  standalone: true
})

export class FooterComponent {}
